import type {TimeRange} from '@flowmaps-com/flowmaps-typescriptmodels';
import moment from 'moment';

// The API expects location-local calendar times; Date JSON would silently shift them to UTC.
export function rawConnectionUploadTimeRange(start: moment.MomentInput, end: moment.MomentInput): TimeRange {
    const format = 'YYYY-MM-DD[T]HH:mm:ss';
    return {start: moment(start).format(format), end: moment(end).format(format)};
}
